module.exports = __webpack_public_path__ + "static/paris-019.thumb-b3292a1b2235d95b5d55378b60b5fece.jpg";